import React from 'react';
import LoadingSpinner from '../components/loadingSpinner';

export const useLoadError = (loading, error) => {
  if (loading) return <LoadingSpinner />;
  if (error) return <p>Error</p>;
  return null;
};